import { Skeleton } from "antd";
import React from "react";

const SubBranchesLoader = () => {
  return (
    <>
      <div className="mb-4 flex w-full overflow-hidden">
        <div className="flex flex-row gap-4">
          <div style={{ position: "relative", width: 367, height: 116 }}>
            <Skeleton.Input
              style={{ width: 367, height: 116, borderRadius: 10 }}
              active={true}
              size="small"
            />
            <Skeleton.Input
              style={{
                position: "absolute",
                width: 200,
                height: 17,
                top: 20,
                left: 10,
                borderRadius: 10,
              }}
              active={true}
              size="small"
            />
            <Skeleton.Input
              style={{
                position: "absolute",
                width: 20,
                height: 15,
                top: 50,
                left: 10,
                borderRadius: 10,
              }}
              active={true}
              size="small"
            />
          </div>
          <div style={{ position: "relative", width: 367, height: 116 }}>
            <Skeleton.Input
              style={{ width: 367, height: 116, borderRadius: 10 }}
              active={true}
              size="small"
            />
            <Skeleton.Input
              style={{
                position: "absolute",
                width: 200,
                height: 17,
                top: 20,
                left: 10,
                borderRadius: 10,
              }}
              active={true}
              size="small"
            />
            <Skeleton.Input
              style={{
                position: "absolute",
                width: 20,
                height: 15,
                top: 50,
                left: 10,
                borderRadius: 10,
              }}
              active={true}
              size="small"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SubBranchesLoader;
